import { useEffect, useState } from 'react';
import { runtimeApi, type ModuleRecord } from '../../api/moduleruntime';

export function UpgradeManagerPage() {
  const [installed, setInstalled] = useState<ModuleRecord[]>([]);
  const [version, setVersion] = useState('1.1.0');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState('');

  const refresh = () => {
    void runtimeApi.listModules().then((r) => setInstalled(r.installed ?? [])).catch((e) => setError(String(e)));
  };

  useEffect(refresh, []);

  const upgrade = async (moduleId: string) => {
    setBusy(moduleId);
    setError('');
    try {
      await runtimeApi.upgrade(moduleId, version);
      refresh();
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy('');
    }
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Upgrade Manager</h1>
      <div className="mt-4 flex items-center gap-3">
        <label className="text-sm">Target version</label>
        <input className="rounded border px-2 py-1 text-sm dark:border-slate-700 dark:bg-slate-900" value={version} onChange={(e) => setVersion(e.target.value)} />
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {installed.map((m) => (
          <div key={m.id} className="flex items-center justify-between rounded-xl border px-4 py-3 dark:border-slate-700">
            <div>
              <p className="font-medium">{m.name}</p>
              <p className="text-xs text-slate-500">Current: v{m.version}{m.previous_version ? ` · previous v${m.previous_version}` : ''}</p>
            </div>
            <button type="button" disabled={busy === m.module_id} className="rounded bg-slate-900 px-3 py-1 text-xs text-white disabled:opacity-50 dark:bg-slate-100 dark:text-slate-900" onClick={() => upgrade(m.module_id)}>
              Upgrade
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
